import { jsx as x, jsxs as oe } from "@emotion/react/jsx-runtime";
import { i as je, a as At, R as xt, n as wt, u as Rt, G as Zt, M as Wt, I as Ot, S as kt } from "./Header-77b81b77.mjs";
import { H as ho } from "./Header-77b81b77.mjs";
import { Global as Gt } from "@emotion/react";
import { AnalyticsProvider as Lt } from "@inflearn/analytics";
import { ThemeProvider as Xt } from "@inflearn/ds-react";
import { ThemeProvider as Vt, NotificationsProvider as Bt, ModalsProvider as Nt } from "@inflearn/ds-react-next";
import { useQueryClient as _t, onlineManager as Ne, notifyManager as Ht, QueryClient as Tt, QueryClientProvider as Ft } from "@tanstack/react-query";
import * as o from "react";
import Ke, { useMemo as Qt, useState as zt, useEffect as $e, cloneElement as Dt } from "react";
import { B as _e, W as Mt, X as qe, Y as Pt, Z as Ut, _ as Yt, $ as Jt, a0 as jt } from "./StickyHeaderSkeleton-1e9bc44c.mjs";
import "@inflearn/ds-react-next/mantine-core-styles.css";
import "@inflearn/ds-react-next/mantine-notifications-styles.css";
import { s as Kt } from "./styleSkeleton-fd2b082e.mjs";
import { i as $t } from "./quicklink-c03b1140.mjs";
import { createInstance as qt, HackleProvider as en } from "@hackler/react-sdk";
import { ChannelTalk as tn } from "./Channeltalk-b5c10bed.mjs";
import nn from "./MoveTop-f8636ac1.mjs";
import { A as rn } from "./onboardingData-e4e3f417-17125e63.mjs";
import on from "./BottomNavigation-650f64ef.mjs";
import { SideSheet as an } from "./SideSheet-605b64f7.mjs";
import "@mantine/hooks";
import "react-error-boundary";
import "@inflearn/datasource-rest";
import "react/jsx-runtime";
import "dayjs";
import "@mantine/core";
import "dayjs/locale/en";
import "dayjs/locale/ko";
import "dayjs/plugin/localizedFormat";
import "dayjs/plugin/updateLocale";
import "react-hook-form";
import "dayjs/plugin/duration";
import "dayjs/plugin/relativeTime";
function D() {
  return D = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, D.apply(this, arguments);
}
/**
   * match-sorter-utils
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
const et = {
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  Ấ: "A",
  Ắ: "A",
  Ẳ: "A",
  Ẵ: "A",
  Ặ: "A",
  Æ: "AE",
  Ầ: "A",
  Ằ: "A",
  Ȃ: "A",
  Ç: "C",
  Ḉ: "C",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  Ế: "E",
  Ḗ: "E",
  Ề: "E",
  Ḕ: "E",
  Ḝ: "E",
  Ȇ: "E",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  Ḯ: "I",
  Ȋ: "I",
  Ð: "D",
  Ñ: "N",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  Ố: "O",
  Ṍ: "O",
  Ṓ: "O",
  Ȏ: "O",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  Ý: "Y",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  ấ: "a",
  ắ: "a",
  ẳ: "a",
  ẵ: "a",
  ặ: "a",
  æ: "ae",
  ầ: "a",
  ằ: "a",
  ȃ: "a",
  ç: "c",
  ḉ: "c",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  ế: "e",
  ḗ: "e",
  ề: "e",
  ḕ: "e",
  ḝ: "e",
  ȇ: "e",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  ḯ: "i",
  ȋ: "i",
  ð: "d",
  ñ: "n",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  ố: "o",
  ṍ: "o",
  ṓ: "o",
  ȏ: "o",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  ý: "y",
  ÿ: "y",
  Ā: "A",
  ā: "a",
  Ă: "A",
  ă: "a",
  Ą: "A",
  ą: "a",
  Ć: "C",
  ć: "c",
  Ĉ: "C",
  ĉ: "c",
  Ċ: "C",
  ċ: "c",
  Č: "C",
  č: "c",
  C̆: "C",
  c̆: "c",
  Ď: "D",
  ď: "d",
  Đ: "D",
  đ: "d",
  Ē: "E",
  ē: "e",
  Ĕ: "E",
  ĕ: "e",
  Ė: "E",
  ė: "e",
  Ę: "E",
  ę: "e",
  Ě: "E",
  ě: "e",
  Ĝ: "G",
  Ǵ: "G",
  ĝ: "g",
  ǵ: "g",
  Ğ: "G",
  ğ: "g",
  Ġ: "G",
  ġ: "g",
  Ģ: "G",
  ģ: "g",
  Ĥ: "H",
  ĥ: "h",
  Ħ: "H",
  ħ: "h",
  Ḫ: "H",
  ḫ: "h",
  Ĩ: "I",
  ĩ: "i",
  Ī: "I",
  ī: "i",
  Ĭ: "I",
  ĭ: "i",
  Į: "I",
  į: "i",
  İ: "I",
  ı: "i",
  Ĳ: "IJ",
  ĳ: "ij",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  Ḱ: "K",
  ḱ: "k",
  K̆: "K",
  k̆: "k",
  Ĺ: "L",
  ĺ: "l",
  Ļ: "L",
  ļ: "l",
  Ľ: "L",
  ľ: "l",
  Ŀ: "L",
  ŀ: "l",
  Ł: "l",
  ł: "l",
  Ḿ: "M",
  ḿ: "m",
  M̆: "M",
  m̆: "m",
  Ń: "N",
  ń: "n",
  Ņ: "N",
  ņ: "n",
  Ň: "N",
  ň: "n",
  ŉ: "n",
  N̆: "N",
  n̆: "n",
  Ō: "O",
  ō: "o",
  Ŏ: "O",
  ŏ: "o",
  Ő: "O",
  ő: "o",
  Œ: "OE",
  œ: "oe",
  P̆: "P",
  p̆: "p",
  Ŕ: "R",
  ŕ: "r",
  Ŗ: "R",
  ŗ: "r",
  Ř: "R",
  ř: "r",
  R̆: "R",
  r̆: "r",
  Ȓ: "R",
  ȓ: "r",
  Ś: "S",
  ś: "s",
  Ŝ: "S",
  ŝ: "s",
  Ş: "S",
  Ș: "S",
  ș: "s",
  ş: "s",
  Š: "S",
  š: "s",
  Ţ: "T",
  ţ: "t",
  ț: "t",
  Ț: "T",
  Ť: "T",
  ť: "t",
  Ŧ: "T",
  ŧ: "t",
  T̆: "T",
  t̆: "t",
  Ũ: "U",
  ũ: "u",
  Ū: "U",
  ū: "u",
  Ŭ: "U",
  ŭ: "u",
  Ů: "U",
  ů: "u",
  Ű: "U",
  ű: "u",
  Ų: "U",
  ų: "u",
  Ȗ: "U",
  ȗ: "u",
  V̆: "V",
  v̆: "v",
  Ŵ: "W",
  ŵ: "w",
  Ẃ: "W",
  ẃ: "w",
  X̆: "X",
  x̆: "x",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Y̆: "Y",
  y̆: "y",
  Ź: "Z",
  ź: "z",
  Ż: "Z",
  ż: "z",
  Ž: "Z",
  ž: "z",
  ſ: "s",
  ƒ: "f",
  Ơ: "O",
  ơ: "o",
  Ư: "U",
  ư: "u",
  Ǎ: "A",
  ǎ: "a",
  Ǐ: "I",
  ǐ: "i",
  Ǒ: "O",
  ǒ: "o",
  Ǔ: "U",
  ǔ: "u",
  Ǖ: "U",
  ǖ: "u",
  Ǘ: "U",
  ǘ: "u",
  Ǚ: "U",
  ǚ: "u",
  Ǜ: "U",
  ǜ: "u",
  Ứ: "U",
  ứ: "u",
  Ṹ: "U",
  ṹ: "u",
  Ǻ: "A",
  ǻ: "a",
  Ǽ: "AE",
  ǽ: "ae",
  Ǿ: "O",
  ǿ: "o",
  Þ: "TH",
  þ: "th",
  Ṕ: "P",
  ṕ: "p",
  Ṥ: "S",
  ṥ: "s",
  X́: "X",
  x́: "x",
  Ѓ: "Г",
  ѓ: "г",
  Ќ: "К",
  ќ: "к",
  A̋: "A",
  a̋: "a",
  E̋: "E",
  e̋: "e",
  I̋: "I",
  i̋: "i",
  Ǹ: "N",
  ǹ: "n",
  Ồ: "O",
  ồ: "o",
  Ṑ: "O",
  ṑ: "o",
  Ừ: "U",
  ừ: "u",
  Ẁ: "W",
  ẁ: "w",
  Ỳ: "Y",
  ỳ: "y",
  Ȁ: "A",
  ȁ: "a",
  Ȅ: "E",
  ȅ: "e",
  Ȉ: "I",
  ȉ: "i",
  Ȍ: "O",
  ȍ: "o",
  Ȑ: "R",
  ȑ: "r",
  Ȕ: "U",
  ȕ: "u",
  B̌: "B",
  b̌: "b",
  Č̣: "C",
  č̣: "c",
  Ê̌: "E",
  ê̌: "e",
  F̌: "F",
  f̌: "f",
  Ǧ: "G",
  ǧ: "g",
  Ȟ: "H",
  ȟ: "h",
  J̌: "J",
  ǰ: "j",
  Ǩ: "K",
  ǩ: "k",
  M̌: "M",
  m̌: "m",
  P̌: "P",
  p̌: "p",
  Q̌: "Q",
  q̌: "q",
  Ř̩: "R",
  ř̩: "r",
  Ṧ: "S",
  ṧ: "s",
  V̌: "V",
  v̌: "v",
  W̌: "W",
  w̌: "w",
  X̌: "X",
  x̌: "x",
  Y̌: "Y",
  y̌: "y",
  A̧: "A",
  a̧: "a",
  B̧: "B",
  b̧: "b",
  Ḑ: "D",
  ḑ: "d",
  Ȩ: "E",
  ȩ: "e",
  Ɛ̧: "E",
  ɛ̧: "e",
  Ḩ: "H",
  ḩ: "h",
  I̧: "I",
  i̧: "i",
  Ɨ̧: "I",
  ɨ̧: "i",
  M̧: "M",
  m̧: "m",
  O̧: "O",
  o̧: "o",
  Q̧: "Q",
  q̧: "q",
  U̧: "U",
  u̧: "u",
  X̧: "X",
  x̧: "x",
  Z̧: "Z",
  z̧: "z"
}, ln = Object.keys(et).join("|"), sn = new RegExp(ln, "g");
function un(e) {
  return e.replace(sn, (t) => et[t]);
}
/**
 * @name match-sorter
 * @license MIT license.
 * @copyright (c) 2099 Kent C. Dodds
 * @author Kent C. Dodds <me@kentcdodds.com> (https://kentcdodds.com)
 */
const G = {
  CASE_SENSITIVE_EQUAL: 7,
  EQUAL: 6,
  STARTS_WITH: 5,
  WORD_STARTS_WITH: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
};
function cn(e, t, n) {
  var r;
  if (n = n || {}, n.threshold = (r = n.threshold) != null ? r : G.MATCHES, !n.accessors) {
    const i = He(e, t, n);
    return {
      // ends up being duplicate of 'item' in matches but consistent
      rankedValue: e,
      rank: i,
      accessorIndex: -1,
      accessorThreshold: n.threshold,
      passed: i >= n.threshold
    };
  }
  const a = mn(e, n.accessors), l = {
    rankedValue: e,
    rank: G.NO_MATCH,
    accessorIndex: -1,
    accessorThreshold: n.threshold,
    passed: !1
  };
  for (let i = 0; i < a.length; i++) {
    const s = a[i];
    let u = He(s.itemValue, t, n);
    const {
      minRanking: p,
      maxRanking: m,
      threshold: d = n.threshold
    } = s.attributes;
    u < p && u >= G.MATCHES ? u = p : u > m && (u = m), u = Math.min(u, m), u >= d && u > l.rank && (l.rank = u, l.passed = !0, l.accessorIndex = i, l.accessorThreshold = d, l.rankedValue = s.itemValue);
  }
  return l;
}
function He(e, t, n) {
  return e = Te(e, n), t = Te(t, n), t.length > e.length ? G.NO_MATCH : e === t ? G.CASE_SENSITIVE_EQUAL : (e = e.toLowerCase(), t = t.toLowerCase(), e === t ? G.EQUAL : e.startsWith(t) ? G.STARTS_WITH : e.includes(` ${t}`) ? G.WORD_STARTS_WITH : e.includes(t) ? G.CONTAINS : t.length === 1 ? G.NO_MATCH : fn(e).includes(t) ? G.ACRONYM : dn(e, t));
}
function fn(e) {
  let t = "";
  return e.split(" ").forEach((r) => {
    r.split("-").forEach((l) => {
      t += l.substr(0, 1);
    });
  }), t;
}
function dn(e, t) {
  let n = 0, r = 0;
  function a(u, p, m) {
    for (let d = m, g = p.length; d < g; d++)
      if (p[d] === u)
        return n += 1, d + 1;
    return -1;
  }
  function l(u) {
    const p = 1 / u, m = n / t.length;
    return G.MATCHES + m * p;
  }
  const i = a(t[0], e, 0);
  if (i < 0)
    return G.NO_MATCH;
  r = i;
  for (let u = 1, p = t.length; u < p; u++) {
    const m = t[u];
    if (r = a(m, e, r), !(r > -1))
      return G.NO_MATCH;
  }
  const s = r - i;
  return l(s);
}
function Te(e, t) {
  let {
    keepDiacritics: n
  } = t;
  return e = `${e}`, n || (e = un(e)), e;
}
function pn(e, t) {
  let n = t;
  typeof t == "object" && (n = t.accessor);
  const r = n(e);
  return r == null ? [] : Array.isArray(r) ? r : [String(r)];
}
function mn(e, t) {
  const n = [];
  for (let r = 0, a = t.length; r < a; r++) {
    const l = t[r], i = gn(l), s = pn(e, l);
    for (let u = 0, p = s.length; u < p; u++)
      n.push({
        itemValue: s[u],
        attributes: i
      });
  }
  return n;
}
const Fe = {
  maxRanking: 1 / 0,
  minRanking: -1 / 0
};
function gn(e) {
  return typeof e == "function" ? Fe : {
    ...Fe,
    ...e
  };
}
const yn = (e) => {
  try {
    const t = localStorage.getItem(e);
    return typeof t == "string" ? JSON.parse(t) : void 0;
  } catch {
    return;
  }
};
function M(e, t) {
  const [n, r] = o.useState();
  o.useEffect(() => {
    const l = yn(e);
    r(typeof l > "u" || l === null ? typeof t == "function" ? t() : t : l);
  }, [t, e]);
  const a = o.useCallback((l) => {
    r((i) => {
      let s = l;
      typeof l == "function" && (s = l(i));
      try {
        localStorage.setItem(e, JSON.stringify(s));
      } catch {
      }
      return s;
    });
  }, [e]);
  return [n, a];
}
var bn = (
  /** @class */
  function() {
    function e() {
      this.keyToValue = /* @__PURE__ */ new Map(), this.valueToKey = /* @__PURE__ */ new Map();
    }
    return e.prototype.set = function(t, n) {
      this.keyToValue.set(t, n), this.valueToKey.set(n, t);
    }, e.prototype.getByKey = function(t) {
      return this.keyToValue.get(t);
    }, e.prototype.getByValue = function(t) {
      return this.valueToKey.get(t);
    }, e.prototype.clear = function() {
      this.keyToValue.clear(), this.valueToKey.clear();
    }, e;
  }()
), tt = (
  /** @class */
  function() {
    function e(t) {
      this.generateIdentifier = t, this.kv = new bn();
    }
    return e.prototype.register = function(t, n) {
      this.kv.getByValue(t) || (n || (n = this.generateIdentifier(t)), this.kv.set(n, t));
    }, e.prototype.clear = function() {
      this.kv.clear();
    }, e.prototype.getIdentifier = function(t) {
      return this.kv.getByValue(t);
    }, e.prototype.getValue = function(t) {
      return this.kv.getByKey(t);
    }, e;
  }()
), hn = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, a) {
      r.__proto__ = a;
    } || function(r, a) {
      for (var l in a)
        Object.prototype.hasOwnProperty.call(a, l) && (r[l] = a[l]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), vn = (
  /** @class */
  function(e) {
    hn(t, e);
    function t() {
      var n = e.call(this, function(r) {
        return r.name;
      }) || this;
      return n.classToAllowedProps = /* @__PURE__ */ new Map(), n;
    }
    return t.prototype.register = function(n, r) {
      typeof r == "object" ? (r.allowProps && this.classToAllowedProps.set(n, r.allowProps), e.prototype.register.call(this, n, r.identifier)) : e.prototype.register.call(this, n, r);
    }, t.prototype.getAllowedProps = function(n) {
      return this.classToAllowedProps.get(n);
    }, t;
  }(tt)
), Cn = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), a, l = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = r.next()).done; )
      l.push(a.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      a && !a.done && (n = r.return) && n.call(r);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return l;
};
function In(e) {
  if ("values" in Object)
    return Object.values(e);
  var t = [];
  for (var n in e)
    e.hasOwnProperty(n) && t.push(e[n]);
  return t;
}
function En(e, t) {
  var n = In(e);
  if ("find" in n)
    return n.find(t);
  for (var r = n, a = 0; a < r.length; a++) {
    var l = r[a];
    if (t(l))
      return l;
  }
}
function ee(e, t) {
  Object.entries(e).forEach(function(n) {
    var r = Cn(n, 2), a = r[0], l = r[1];
    return t(l, a);
  });
}
function me(e, t) {
  return e.indexOf(t) !== -1;
}
function Qe(e, t) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    if (t(r))
      return r;
  }
}
var Sn = (
  /** @class */
  function() {
    function e() {
      this.transfomers = {};
    }
    return e.prototype.register = function(t) {
      this.transfomers[t.name] = t;
    }, e.prototype.findApplicable = function(t) {
      return En(this.transfomers, function(n) {
        return n.isApplicable(t);
      });
    }, e.prototype.findByName = function(t) {
      return this.transfomers[t];
    }, e;
  }()
), An = function(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}, nt = function(e) {
  return typeof e > "u";
}, xn = function(e) {
  return e === null;
}, ie = function(e) {
  return typeof e != "object" || e === null || e === Object.prototype ? !1 : Object.getPrototypeOf(e) === null ? !0 : Object.getPrototypeOf(e) === Object.prototype;
}, Ae = function(e) {
  return ie(e) && Object.keys(e).length === 0;
}, U = function(e) {
  return Array.isArray(e);
}, wn = function(e) {
  return typeof e == "string";
}, Rn = function(e) {
  return typeof e == "number" && !isNaN(e);
}, Zn = function(e) {
  return typeof e == "boolean";
}, Wn = function(e) {
  return e instanceof RegExp;
}, le = function(e) {
  return e instanceof Map;
}, se = function(e) {
  return e instanceof Set;
}, rt = function(e) {
  return An(e) === "Symbol";
}, On = function(e) {
  return e instanceof Date && !isNaN(e.valueOf());
}, kn = function(e) {
  return e instanceof Error;
}, ze = function(e) {
  return typeof e == "number" && isNaN(e);
}, Gn = function(e) {
  return Zn(e) || xn(e) || nt(e) || Rn(e) || wn(e) || rt(e);
}, Ln = function(e) {
  return typeof e == "bigint";
}, Xn = function(e) {
  return e === 1 / 0 || e === -1 / 0;
}, Vn = function(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}, Bn = function(e) {
  return e instanceof URL;
}, ot = function(e) {
  return e.replace(/\./g, "\\.");
}, ve = function(e) {
  return e.map(String).map(ot).join(".");
}, ae = function(e) {
  for (var t = [], n = "", r = 0; r < e.length; r++) {
    var a = e.charAt(r), l = a === "\\" && e.charAt(r + 1) === ".";
    if (l) {
      n += ".", r++;
      continue;
    }
    var i = a === ".";
    if (i) {
      t.push(n), n = "";
      continue;
    }
    n += a;
  }
  var s = n;
  return t.push(s), t;
}, xe = globalThis && globalThis.__assign || function() {
  return xe = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, xe.apply(this, arguments);
}, we = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), a, l = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = r.next()).done; )
      l.push(a.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      a && !a.done && (n = r.return) && n.call(r);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return l;
}, Re = globalThis && globalThis.__spreadArray || function(e, t) {
  for (var n = 0, r = t.length, a = e.length; n < r; n++, a++)
    e[a] = t[n];
  return e;
};
function B(e, t, n, r) {
  return {
    isApplicable: e,
    annotation: t,
    transform: n,
    untransform: r
  };
}
var at = [
  B(nt, "undefined", function() {
    return null;
  }, function() {
  }),
  B(Ln, "bigint", function(e) {
    return e.toString();
  }, function(e) {
    return typeof BigInt < "u" ? BigInt(e) : (console.error("Please add a BigInt polyfill."), e);
  }),
  B(On, "Date", function(e) {
    return e.toISOString();
  }, function(e) {
    return new Date(e);
  }),
  B(kn, "Error", function(e, t) {
    var n = {
      name: e.name,
      message: e.message
    };
    return t.allowedErrorProps.forEach(function(r) {
      n[r] = e[r];
    }), n;
  }, function(e, t) {
    var n = new Error(e.message);
    return n.name = e.name, n.stack = e.stack, t.allowedErrorProps.forEach(function(r) {
      n[r] = e[r];
    }), n;
  }),
  B(Wn, "regexp", function(e) {
    return "" + e;
  }, function(e) {
    var t = e.slice(1, e.lastIndexOf("/")), n = e.slice(e.lastIndexOf("/") + 1);
    return new RegExp(t, n);
  }),
  B(
    se,
    "set",
    // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    function(e) {
      return Re([], we(e.values()));
    },
    function(e) {
      return new Set(e);
    }
  ),
  B(le, "map", function(e) {
    return Re([], we(e.entries()));
  }, function(e) {
    return new Map(e);
  }),
  B(function(e) {
    return ze(e) || Xn(e);
  }, "number", function(e) {
    return ze(e) ? "NaN" : e > 0 ? "Infinity" : "-Infinity";
  }, Number),
  B(function(e) {
    return e === 0 && 1 / e === -1 / 0;
  }, "number", function() {
    return "-0";
  }, Number),
  B(Bn, "URL", function(e) {
    return e.toString();
  }, function(e) {
    return new URL(e);
  })
];
function ye(e, t, n, r) {
  return {
    isApplicable: e,
    annotation: t,
    transform: n,
    untransform: r
  };
}
var it = ye(function(e, t) {
  if (rt(e)) {
    var n = !!t.symbolRegistry.getIdentifier(e);
    return n;
  }
  return !1;
}, function(e, t) {
  var n = t.symbolRegistry.getIdentifier(e);
  return ["symbol", n];
}, function(e) {
  return e.description;
}, function(e, t, n) {
  var r = n.symbolRegistry.getValue(t[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown symbol");
  return r;
}), Nn = [
  Int8Array,
  Uint8Array,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array,
  Uint8ClampedArray
].reduce(function(e, t) {
  return e[t.name] = t, e;
}, {}), lt = ye(Vn, function(e) {
  return ["typed-array", e.constructor.name];
}, function(e) {
  return Re([], we(e));
}, function(e, t) {
  var n = Nn[t[1]];
  if (!n)
    throw new Error("Trying to deserialize unknown typed array");
  return new n(e);
});
function st(e, t) {
  if (e != null && e.constructor) {
    var n = !!t.classRegistry.getIdentifier(e.constructor);
    return n;
  }
  return !1;
}
var ut = ye(st, function(e, t) {
  var n = t.classRegistry.getIdentifier(e.constructor);
  return ["class", n];
}, function(e, t) {
  var n = t.classRegistry.getAllowedProps(e.constructor);
  if (!n)
    return xe({}, e);
  var r = {};
  return n.forEach(function(a) {
    r[a] = e[a];
  }), r;
}, function(e, t, n) {
  var r = n.classRegistry.getValue(t[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown class - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564");
  return Object.assign(Object.create(r.prototype), e);
}), ct = ye(function(e, t) {
  return !!t.customTransformerRegistry.findApplicable(e);
}, function(e, t) {
  var n = t.customTransformerRegistry.findApplicable(e);
  return ["custom", n.name];
}, function(e, t) {
  var n = t.customTransformerRegistry.findApplicable(e);
  return n.serialize(e);
}, function(e, t, n) {
  var r = n.customTransformerRegistry.findByName(t[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown custom value");
  return r.deserialize(e);
}), _n = [ut, it, ct, lt], De = function(e, t) {
  var n = Qe(_n, function(a) {
    return a.isApplicable(e, t);
  });
  if (n)
    return {
      value: n.transform(e, t),
      type: n.annotation(e, t)
    };
  var r = Qe(at, function(a) {
    return a.isApplicable(e, t);
  });
  if (r)
    return {
      value: r.transform(e, t),
      type: r.annotation
    };
}, ft = {};
at.forEach(function(e) {
  ft[e.annotation] = e;
});
var Hn = function(e, t, n) {
  if (U(t))
    switch (t[0]) {
      case "symbol":
        return it.untransform(e, t, n);
      case "class":
        return ut.untransform(e, t, n);
      case "custom":
        return ct.untransform(e, t, n);
      case "typed-array":
        return lt.untransform(e, t, n);
      default:
        throw new Error("Unknown transformation: " + t);
    }
  else {
    var r = ft[t];
    if (!r)
      throw new Error("Unknown transformation: " + t);
    return r.untransform(e, n);
  }
}, q = function(e, t) {
  for (var n = e.keys(); t > 0; )
    n.next(), t--;
  return n.next().value;
};
function dt(e) {
  if (me(e, "__proto__"))
    throw new Error("__proto__ is not allowed as a property");
  if (me(e, "prototype"))
    throw new Error("prototype is not allowed as a property");
  if (me(e, "constructor"))
    throw new Error("constructor is not allowed as a property");
}
var Tn = function(e, t) {
  dt(t);
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    if (se(e))
      e = q(e, +r);
    else if (le(e)) {
      var a = +r, l = +t[++n] == 0 ? "key" : "value", i = q(e, a);
      switch (l) {
        case "key":
          e = i;
          break;
        case "value":
          e = e.get(i);
          break;
      }
    } else
      e = e[r];
  }
  return e;
}, Ze = function(e, t, n) {
  if (dt(t), t.length === 0)
    return n(e);
  for (var r = e, a = 0; a < t.length - 1; a++) {
    var l = t[a];
    if (U(r)) {
      var i = +l;
      r = r[i];
    } else if (ie(r))
      r = r[l];
    else if (se(r)) {
      var s = +l;
      r = q(r, s);
    } else if (le(r)) {
      var u = a === t.length - 2;
      if (u)
        break;
      var s = +l, p = +t[++a] == 0 ? "key" : "value", m = q(r, s);
      switch (p) {
        case "key":
          r = m;
          break;
        case "value":
          r = r.get(m);
          break;
      }
    }
  }
  var d = t[t.length - 1];
  if (U(r) ? r[+d] = n(r[+d]) : ie(r) && (r[d] = n(r[d])), se(r)) {
    var g = q(r, +d), c = n(g);
    g !== c && (r.delete(g), r.add(c));
  }
  if (le(r)) {
    var s = +t[t.length - 2], f = q(r, s), p = +d == 0 ? "key" : "value";
    switch (p) {
      case "key": {
        var y = n(f);
        r.set(y, r.get(f)), y !== f && r.delete(f);
        break;
      }
      case "value": {
        r.set(f, n(r.get(f)));
        break;
      }
    }
  }
  return e;
}, Q = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), a, l = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = r.next()).done; )
      l.push(a.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      a && !a.done && (n = r.return) && n.call(r);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return l;
}, P = globalThis && globalThis.__spreadArray || function(e, t) {
  for (var n = 0, r = t.length, a = e.length; n < r; n++, a++)
    e[a] = t[n];
  return e;
};
function We(e, t, n) {
  if (n === void 0 && (n = []), !!e) {
    if (!U(e)) {
      ee(e, function(i, s) {
        return We(i, t, P(P([], Q(n)), Q(ae(s))));
      });
      return;
    }
    var r = Q(e, 2), a = r[0], l = r[1];
    l && ee(l, function(i, s) {
      We(i, t, P(P([], Q(n)), Q(ae(s))));
    }), t(a, n);
  }
}
function Fn(e, t, n) {
  return We(t, function(r, a) {
    e = Ze(e, a, function(l) {
      return Hn(l, r, n);
    });
  }), e;
}
function Qn(e, t) {
  function n(i, s) {
    var u = Tn(e, ae(s));
    i.map(ae).forEach(function(p) {
      e = Ze(e, p, function() {
        return u;
      });
    });
  }
  if (U(t)) {
    var r = Q(t, 2), a = r[0], l = r[1];
    a.forEach(function(i) {
      e = Ze(e, ae(i), function() {
        return e;
      });
    }), l && ee(l, n);
  } else
    ee(t, n);
  return e;
}
var zn = function(e, t) {
  return ie(e) || U(e) || le(e) || se(e) || st(e, t);
};
function Dn(e, t, n) {
  var r = n.get(e);
  r ? r.push(t) : n.set(e, [t]);
}
function Mn(e, t) {
  var n = {}, r = void 0;
  return e.forEach(function(a) {
    if (!(a.length <= 1)) {
      t || (a = a.map(function(u) {
        return u.map(String);
      }).sort(function(u, p) {
        return u.length - p.length;
      }));
      var l = Q(a), i = l[0], s = l.slice(1);
      i.length === 0 ? r = s.map(ve) : n[ve(i)] = s.map(ve);
    }
  }), r ? Ae(n) ? [r] : [r, n] : Ae(n) ? void 0 : n;
}
var pt = function(e, t, n, r, a, l, i) {
  var s;
  a === void 0 && (a = []), l === void 0 && (l = []), i === void 0 && (i = /* @__PURE__ */ new Map());
  var u = Gn(e);
  if (!u) {
    Dn(e, a, t);
    var p = i.get(e);
    if (p)
      return r ? {
        transformedValue: null
      } : p;
  }
  if (!zn(e, n)) {
    var m = De(e, n), d = m ? {
      transformedValue: m.value,
      annotations: [m.type]
    } : {
      transformedValue: e
    };
    return u || i.set(e, d), d;
  }
  if (me(l, e))
    return {
      transformedValue: null
    };
  var g = De(e, n), c = (s = g == null ? void 0 : g.value) !== null && s !== void 0 ? s : e, f = U(c) ? [] : {}, y = {};
  ee(c, function(R, A) {
    var v = pt(R, t, n, r, P(P([], Q(a)), [A]), P(P([], Q(l)), [e]), i);
    f[A] = v.transformedValue, U(v.annotations) ? y[A] = v.annotations : ie(v.annotations) && ee(v.annotations, function(b, w) {
      y[ot(A) + "." + w] = b;
    });
  });
  var I = Ae(y) ? {
    transformedValue: f,
    annotations: g ? [g.type] : void 0
  } : {
    transformedValue: f,
    annotations: g ? [g.type, y] : y
  };
  return u || i.set(e, I), I;
};
function mt(e) {
  return Object.prototype.toString.call(e).slice(8, -1);
}
function Me(e) {
  return mt(e) === "Array";
}
function Pn(e) {
  if (mt(e) !== "Object")
    return !1;
  const t = Object.getPrototypeOf(e);
  return !!t && t.constructor === Object && t === Object.prototype;
}
function Un(e, t, n, r, a) {
  const l = {}.propertyIsEnumerable.call(r, t) ? "enumerable" : "nonenumerable";
  l === "enumerable" && (e[t] = n), a && l === "nonenumerable" && Object.defineProperty(e, t, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}
function Oe(e, t = {}) {
  if (Me(e))
    return e.map((a) => Oe(a, t));
  if (!Pn(e))
    return e;
  const n = Object.getOwnPropertyNames(e), r = Object.getOwnPropertySymbols(e);
  return [...n, ...r].reduce((a, l) => {
    if (Me(t.props) && !t.props.includes(l))
      return a;
    const i = e[l], s = Oe(i, t);
    return Un(a, l, s, e, t.nonenumerable), a;
  }, {});
}
var J = globalThis && globalThis.__assign || function() {
  return J = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, J.apply(this, arguments);
}, Yn = globalThis && globalThis.__read || function(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), a, l = [], i;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = r.next()).done; )
      l.push(a.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      a && !a.done && (n = r.return) && n.call(r);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return l;
}, Jn = globalThis && globalThis.__spreadArray || function(e, t) {
  for (var n = 0, r = t.length, a = e.length; n < r; n++, a++)
    e[a] = t[n];
  return e;
}, _ = (
  /** @class */
  function() {
    function e(t) {
      var n = t === void 0 ? {} : t, r = n.dedupe, a = r === void 0 ? !1 : r;
      this.classRegistry = new vn(), this.symbolRegistry = new tt(function(l) {
        var i;
        return (i = l.description) !== null && i !== void 0 ? i : "";
      }), this.customTransformerRegistry = new Sn(), this.allowedErrorProps = [], this.dedupe = a;
    }
    return e.prototype.serialize = function(t) {
      var n = /* @__PURE__ */ new Map(), r = pt(t, n, this, this.dedupe), a = {
        json: r.transformedValue
      };
      r.annotations && (a.meta = J(J({}, a.meta), { values: r.annotations }));
      var l = Mn(n, this.dedupe);
      return l && (a.meta = J(J({}, a.meta), { referentialEqualities: l })), a;
    }, e.prototype.deserialize = function(t) {
      var n = t.json, r = t.meta, a = Oe(n);
      return r != null && r.values && (a = Fn(a, r.values, this)), r != null && r.referentialEqualities && (a = Qn(a, r.referentialEqualities)), a;
    }, e.prototype.stringify = function(t) {
      return JSON.stringify(this.serialize(t));
    }, e.prototype.parse = function(t) {
      return this.deserialize(JSON.parse(t));
    }, e.prototype.registerClass = function(t, n) {
      this.classRegistry.register(t, n);
    }, e.prototype.registerSymbol = function(t, n) {
      this.symbolRegistry.register(t, n);
    }, e.prototype.registerCustom = function(t, n) {
      this.customTransformerRegistry.register(J({ name: n }, t));
    }, e.prototype.allowErrorProps = function() {
      for (var t, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      (t = this.allowedErrorProps).push.apply(t, Jn([], Yn(n)));
    }, e.defaultInstance = new e(), e.serialize = e.defaultInstance.serialize.bind(e.defaultInstance), e.deserialize = e.defaultInstance.deserialize.bind(e.defaultInstance), e.stringify = e.defaultInstance.stringify.bind(e.defaultInstance), e.parse = e.defaultInstance.parse.bind(e.defaultInstance), e.registerClass = e.defaultInstance.registerClass.bind(e.defaultInstance), e.registerSymbol = e.defaultInstance.registerSymbol.bind(e.defaultInstance), e.registerCustom = e.defaultInstance.registerCustom.bind(e.defaultInstance), e.allowErrorProps = e.defaultInstance.allowErrorProps.bind(e.defaultInstance), e;
  }()
);
_.serialize;
_.deserialize;
_.stringify;
_.parse;
_.registerClass;
_.registerCustom;
_.registerSymbol;
_.allowErrorProps;
const h = {
  background: "#0b1521",
  backgroundAlt: "#132337",
  foreground: "white",
  gray: "#3f4e60",
  grayAlt: "#222e3e",
  inputBackgroundColor: "#fff",
  inputTextColor: "#000",
  success: "#00ab52",
  danger: "#ff0085",
  active: "#006bff",
  paused: "#8c49eb",
  warning: "#ffb200"
}, gt = /* @__PURE__ */ o.createContext(h);
function yt({
  theme: e,
  ...t
}) {
  return /* @__PURE__ */ o.createElement(gt.Provider, D({
    value: e
  }, t));
}
function jn() {
  return o.useContext(gt);
}
function Kn(e) {
  const [t, n] = o.useState(() => {
    if (typeof window < "u")
      return window.matchMedia(e).matches;
  });
  return o.useEffect(() => {
    if (typeof window < "u") {
      const r = window.matchMedia(e), a = ({
        matches: l
      }) => n(l);
      return r.addListener(a), () => {
        r.removeListener(a);
      };
    }
  }, [t, e, n]), t;
}
function bt({
  queryState: e,
  observerCount: t,
  isStale: n,
  theme: r
}) {
  return e.fetchStatus === "fetching" ? r.active : t ? e.fetchStatus === "paused" ? r.paused : n ? r.warning : r.success : r.gray;
}
function $(e) {
  return e.state.fetchStatus === "fetching" ? "fetching" : e.getObserversCount() ? e.state.fetchStatus === "paused" ? "paused" : e.isStale() ? "stale" : "fresh" : "inactive";
}
function k(e, t, n = {}) {
  return /* @__PURE__ */ o.forwardRef(({
    style: r,
    ...a
  }, l) => {
    const i = jn(), s = Object.entries(n).reduce((u, [p, m]) => Kn(p) ? {
      ...u,
      ...typeof m == "function" ? m(a, i) : m
    } : u, {});
    return /* @__PURE__ */ o.createElement(e, {
      ...a,
      style: {
        ...typeof t == "function" ? t(a, i) : t,
        ...r,
        ...s
      },
      ref: l
    });
  });
}
function $n() {
  const e = o.useRef(!1), t = o.useCallback(() => e.current, []);
  return o.useEffect(() => (e.current = !0, () => {
    e.current = !1;
  }), []), t;
}
const ht = (e, t = !1) => {
  const {
    json: n
  } = _.serialize(e);
  return JSON.stringify(n, null, t ? 2 : void 0);
}, pe = (e) => e.state.fetchStatus !== "idle" ? 0 : e.getObserversCount() ? e.isStale() ? 2 : 1 : 3, qn = (e, t) => e.queryHash.localeCompare(t.queryHash), vt = (e, t) => e.state.dataUpdatedAt < t.state.dataUpdatedAt ? 1 : -1, er = (e, t) => pe(e) === pe(t) ? vt(e, t) : pe(e) > pe(t) ? 1 : -1, Ce = {
  "Status > Last Updated": er,
  "Query Hash": qn,
  "Last Updated": vt
}, ke = 70, ue = 500, tr = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
};
function ge(e) {
  return ["left", "right"].includes(e);
}
function Ct(e) {
  return tr[e];
}
function Be(e, t) {
  return "" + e + (t.charAt(0).toUpperCase() + t.slice(1));
}
function nr({
  position: e = "bottom",
  height: t,
  width: n,
  devtoolsTheme: r,
  isOpen: a,
  isResizing: l,
  panelStyle: i
}) {
  const s = Ct(e), u = Be("border", s), p = ge(e);
  return {
    ...i,
    direction: "ltr",
    position: "fixed",
    [e]: 0,
    [u]: "1px solid " + r.gray,
    transformOrigin: s,
    boxShadow: "0 0 20px rgba(0,0,0,.3)",
    zIndex: 99999,
    // visibility will be toggled after transitions, but set initial state here
    visibility: a ? "visible" : "hidden",
    ...l ? {
      transition: "none"
    } : {
      transition: "all .2s ease"
    },
    ...a ? {
      opacity: 1,
      pointerEvents: "all",
      transform: p ? "translateX(0) scale(1)" : "translateY(0) scale(1)"
    } : {
      opacity: 0,
      pointerEvents: "none",
      transform: p ? "translateX(15px) scale(1.02)" : "translateY(15px) scale(1.02)"
    },
    ...p ? {
      top: 0,
      height: "100vh",
      maxWidth: "90%",
      width: typeof n == "number" && n >= ke ? n : ue
    } : {
      left: 0,
      width: "100%",
      maxHeight: "90%",
      height: typeof t == "number" && t >= ke ? t : ue
    }
  };
}
function rr(e = "bottom") {
  const t = ge(e), n = Ct(e), r = Be("margin", n);
  return {
    position: "absolute",
    cursor: t ? "col-resize" : "row-resize",
    zIndex: 1e5,
    [n]: 0,
    [r]: "-4px",
    ...t ? {
      top: 0,
      height: "100%",
      width: "4px"
    } : {
      width: "100%",
      height: "4px"
    }
  };
}
const or = k("div", (e, t) => ({
  fontSize: "clamp(12px, 1.5vw, 14px)",
  fontFamily: "sans-serif",
  display: "flex",
  backgroundColor: t.background,
  color: t.foreground
}), {
  "(max-width: 700px)": {
    flexDirection: "column"
  },
  "(max-width: 600px)": {
    fontSize: ".9em"
    // flexDirection: 'column',
  }
}), ar = k("div", () => ({
  flex: "1 1 500px",
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  height: "100%"
}), {
  "(max-width: 700px)": (e, t) => ({
    borderTop: "2px solid " + t.gray
  })
}), N = k("button", (e, t) => ({
  appearance: "none",
  fontSize: ".9em",
  fontWeight: "bold",
  background: t.gray,
  border: "0",
  borderRadius: ".3em",
  color: "white",
  padding: ".5em",
  opacity: e.disabled ? ".5" : void 0,
  cursor: "pointer"
})), ir = k("span", {
  display: "flex",
  flexWrap: "wrap",
  gap: "0.5em",
  fontSize: "0.9em"
}), re = k("span", {
  display: "inline-flex",
  alignItems: "center",
  padding: ".2em .4em",
  fontWeight: "bold",
  textShadow: "0 0 10px black",
  borderRadius: ".2em"
}), z = k("code", {
  fontSize: ".9em",
  color: "inherit",
  background: "inherit"
}), lr = k("input", (e, t) => ({
  backgroundColor: t.inputBackgroundColor,
  border: 0,
  borderRadius: ".2em",
  color: t.inputTextColor,
  fontSize: ".9em",
  lineHeight: "1.3",
  padding: ".3em .4em"
})), Ge = k("select", (e, t) => ({
  display: "inline-block",
  fontSize: ".9em",
  fontFamily: "sans-serif",
  fontWeight: "normal",
  lineHeight: "1.3",
  padding: ".3em 1.5em .3em .5em",
  height: "auto",
  border: 0,
  borderRadius: ".2em",
  appearance: "none",
  WebkitAppearance: "none",
  backgroundColor: t.inputBackgroundColor,
  backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='%23444444'><polygon points='0,25 100,25 50,75'/></svg>")`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right .55em center",
  backgroundSize: ".65em auto, 100%",
  color: t.inputTextColor
}), {
  "(max-width: 500px)": {
    display: "none"
  }
});
function Le({
  text: e
}) {
  return /* @__PURE__ */ o.createElement("span", {
    style: {
      position: "absolute",
      width: "0.1px",
      height: "0.1px",
      overflow: "hidden"
    }
  }, e);
}
const Pe = k("div", {
  fontFamily: "Menlo, monospace",
  fontSize: "1em",
  lineHeight: "1.7",
  outline: "none",
  wordBreak: "break-word"
}), sr = k("span", {
  color: "white"
}), ur = k("button", {
  cursor: "pointer",
  color: "white"
}), cr = k("button", {
  cursor: "pointer",
  color: "inherit",
  font: "inherit",
  outline: "inherit",
  background: "transparent",
  border: "none",
  padding: 0
}), fr = ({
  value: e
}) => {
  const [t, n] = o.useState("NoCopy");
  return /* @__PURE__ */ o.createElement("button", {
    onClick: t === "NoCopy" ? () => {
      navigator.clipboard.writeText(_.stringify(e)).then(() => {
        n("SuccessCopy"), setTimeout(() => {
          n("NoCopy");
        }, 1500);
      }, (r) => {
        console.error("Failed to copy: ", r), n("ErrorCopy"), setTimeout(() => {
          n("NoCopy");
        }, 1500);
      });
    } : void 0,
    style: {
      cursor: "pointer",
      color: "inherit",
      font: "inherit",
      outline: "inherit",
      background: "transparent",
      border: "none",
      padding: 0
    }
  }, t === "NoCopy" ? /* @__PURE__ */ o.createElement(mr, null) : t === "SuccessCopy" ? /* @__PURE__ */ o.createElement(yr, null) : /* @__PURE__ */ o.createElement(gr, null));
}, dr = k("span", (e, t) => ({
  color: t.danger
})), Ie = k("div", {
  marginLeft: ".1em",
  paddingLeft: "1em",
  borderLeft: "2px solid rgba(0,0,0,.15)"
}), pr = k("span", {
  color: "grey",
  fontSize: ".7em"
}), Ue = ({
  expanded: e,
  style: t = {}
}) => /* @__PURE__ */ o.createElement("span", {
  style: {
    display: "inline-block",
    transition: "all .1s ease",
    transform: "rotate(" + (e ? 90 : 0) + "deg) " + (t.transform || ""),
    ...t
  }
}, "▶"), mr = () => /* @__PURE__ */ o.createElement("span", {
  "aria-label": "Copy object to clipboard",
  title: "Copy object to clipboard",
  style: {
    paddingLeft: "1em"
  }
}, /* @__PURE__ */ o.createElement("svg", {
  height: "12",
  viewBox: "0 0 16 12",
  width: "10"
}, /* @__PURE__ */ o.createElement("path", {
  fill: "currentColor",
  d: "M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 010 1.5h-1.5a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-1.5a.75.75 0 011.5 0v1.5A1.75 1.75 0 019.25 16h-7.5A1.75 1.75 0 010 14.25v-7.5z"
}), /* @__PURE__ */ o.createElement("path", {
  fill: "currentColor",
  d: "M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0114.25 11h-7.5A1.75 1.75 0 015 9.25v-7.5zm1.75-.25a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-7.5a.25.25 0 00-.25-.25h-7.5z"
}))), gr = () => /* @__PURE__ */ o.createElement("span", {
  "aria-label": "Failed copying to clipboard",
  title: "Failed copying to clipboard",
  style: {
    paddingLeft: "1em",
    display: "flex",
    alignItems: "center"
  }
}, /* @__PURE__ */ o.createElement("svg", {
  height: "12",
  viewBox: "0 0 16 12",
  width: "10",
  display: "block"
}, /* @__PURE__ */ o.createElement("path", {
  fill: "red",
  d: "M3.72 3.72a.75.75 0 011.06 0L8 6.94l3.22-3.22a.75.75 0 111.06 1.06L9.06 8l3.22 3.22a.75.75 0 11-1.06 1.06L8 9.06l-3.22 3.22a.75.75 0 01-1.06-1.06L6.94 8 3.72 4.78a.75.75 0 010-1.06z"
})), /* @__PURE__ */ o.createElement("span", {
  style: {
    color: "red",
    fontSize: "12px",
    paddingLeft: "4px",
    position: "relative",
    top: "2px"
  }
}, "See console")), yr = () => /* @__PURE__ */ o.createElement("span", {
  "aria-label": "Object copied to clipboard",
  title: "Object copied to clipboard",
  style: {
    paddingLeft: "1em",
    display: "inline-block",
    verticalAlign: "middle"
  }
}, /* @__PURE__ */ o.createElement("svg", {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  display: "block"
}, /* @__PURE__ */ o.createElement("path", {
  fill: "green",
  d: "M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z"
})));
function br(e, t) {
  if (t < 1)
    return [];
  let n = 0;
  const r = [];
  for (; n < e.length; )
    r.push(e.slice(n, n + t)), n = n + t;
  return r;
}
const hr = ({
  handleEntry: e,
  label: t,
  value: n,
  subEntries: r = [],
  subEntryPages: a = [],
  type: l,
  expanded: i = !1,
  copyable: s = !1,
  toggleExpanded: u,
  pageSize: p
}) => {
  const [m, d] = o.useState([]);
  return /* @__PURE__ */ o.createElement(Pe, {
    key: t
  }, a.length ? /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(cr, {
    onClick: () => u()
  }, /* @__PURE__ */ o.createElement(Ue, {
    expanded: i
  }), " ", t, " ", /* @__PURE__ */ o.createElement(pr, null, String(l).toLowerCase() === "iterable" ? "(Iterable) " : "", r.length, " ", r.length > 1 ? "items" : "item")), s ? /* @__PURE__ */ o.createElement(fr, {
    value: n
  }) : null, i ? a.length === 1 ? /* @__PURE__ */ o.createElement(Ie, null, r.map(e)) : /* @__PURE__ */ o.createElement(Ie, null, a.map((g, c) => /* @__PURE__ */ o.createElement("div", {
    key: c
  }, /* @__PURE__ */ o.createElement(Pe, null, /* @__PURE__ */ o.createElement(ur, {
    onClick: () => d((f) => f.includes(c) ? f.filter((y) => y !== c) : [...f, c])
  }, /* @__PURE__ */ o.createElement(Ue, {
    expanded: i
  }), " [", c * p, " ...", " ", c * p + p - 1, "]"), m.includes(c) ? /* @__PURE__ */ o.createElement(Ie, null, g.map(e)) : null)))) : null) : /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(sr, null, t, ":"), " ", /* @__PURE__ */ o.createElement(dr, null, ht(n))));
};
function vr(e) {
  return Symbol.iterator in e;
}
function Xe({
  value: e,
  defaultExpanded: t,
  renderer: n = hr,
  pageSize: r = 100,
  copyable: a = !1,
  ...l
}) {
  const [i, s] = o.useState(!!t), u = o.useCallback(() => s((c) => !c), []);
  let p = typeof e, m = [];
  const d = (c) => {
    const f = t === !0 ? {
      [c.label]: !0
    } : t == null ? void 0 : t[c.label];
    return {
      ...c,
      defaultExpanded: f
    };
  };
  Array.isArray(e) ? (p = "array", m = e.map((c, f) => d({
    label: f.toString(),
    value: c
  }))) : e !== null && typeof e == "object" && vr(e) && typeof e[Symbol.iterator] == "function" ? (p = "Iterable", m = Array.from(e, (c, f) => d({
    label: f.toString(),
    value: c
  }))) : typeof e == "object" && e !== null && (p = "object", m = Object.entries(e).map(([c, f]) => d({
    label: c,
    value: f
  })));
  const g = br(m, r);
  return n({
    handleEntry: (c) => /* @__PURE__ */ o.createElement(Xe, D({
      key: c.label,
      value: e,
      renderer: n,
      copyable: a
    }, l, c)),
    type: p,
    subEntries: m,
    subEntryPages: g,
    value: e,
    expanded: i,
    copyable: a,
    toggleExpanded: u,
    pageSize: r,
    ...l
  });
}
function It(e) {
  return /* @__PURE__ */ o.createElement("svg", D({
    width: "40px",
    height: "40px",
    viewBox: "0 0 190 190",
    version: "1.1"
  }, e), /* @__PURE__ */ o.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ o.createElement("g", {
    transform: "translate(-33.000000, 0.000000)"
  }, /* @__PURE__ */ o.createElement("path", {
    d: "M72.7239712,61.3436237 C69.631224,46.362877 68.9675112,34.8727722 70.9666331,26.5293551 C72.1555965,21.5671678 74.3293088,17.5190846 77.6346064,14.5984631 C81.1241394,11.5150478 85.5360327,10.0020122 90.493257,10.0020122 C98.6712013,10.0020122 107.26826,13.7273214 116.455725,20.8044264 C120.20312,23.6910458 124.092437,27.170411 128.131651,31.2444746 C128.45314,30.8310265 128.816542,30.4410453 129.22143,30.0806152 C140.64098,19.9149716 150.255245,13.5989272 158.478408,11.1636507 C163.367899,9.715636 167.958526,9.57768202 172.138936,10.983031 C176.551631,12.4664684 180.06766,15.5329489 182.548314,19.8281091 C186.642288,26.9166735 187.721918,36.2310983 186.195595,47.7320243 C185.573451,52.4199112 184.50985,57.5263831 183.007094,63.0593153 C183.574045,63.1277086 184.142416,63.2532808 184.705041,63.4395297 C199.193932,68.2358678 209.453582,73.3937462 215.665021,79.2882839 C219.360669,82.7953831 221.773972,86.6998434 222.646365,91.0218204 C223.567176,95.5836746 222.669313,100.159332 220.191548,104.451297 C216.105211,111.529614 208.591643,117.11221 197.887587,121.534031 C193.589552,123.309539 188.726579,124.917559 183.293259,126.363748 C183.541176,126.92292 183.733521,127.516759 183.862138,128.139758 C186.954886,143.120505 187.618598,154.61061 185.619477,162.954027 C184.430513,167.916214 182.256801,171.964297 178.951503,174.884919 C175.46197,177.968334 171.050077,179.48137 166.092853,179.48137 C157.914908,179.48137 149.31785,175.756061 140.130385,168.678956 C136.343104,165.761613 132.410866,162.238839 128.325434,158.108619 C127.905075,158.765474 127.388968,159.376011 126.77857,159.919385 C115.35902,170.085028 105.744755,176.401073 97.5215915,178.836349 C92.6321009,180.284364 88.0414736,180.422318 83.8610636,179.016969 C79.4483686,177.533532 75.9323404,174.467051 73.4516862,170.171891 C69.3577116,163.083327 68.2780823,153.768902 69.8044053,142.267976 C70.449038,137.410634 71.56762,132.103898 73.1575891,126.339009 C72.5361041,126.276104 71.9120754,126.144816 71.2949591,125.940529 C56.8060684,121.144191 46.5464184,115.986312 40.3349789,110.091775 C36.6393312,106.584675 34.2260275,102.680215 33.3536352,98.3582381 C32.4328237,93.7963839 33.3306866,89.2207269 35.8084524,84.9287618 C39.8947886,77.8504443 47.4083565,72.2678481 58.1124133,67.8460273 C62.5385143,66.0176154 67.5637208,64.366822 73.1939394,62.8874674 C72.9933393,62.3969171 72.8349374,61.8811235 72.7239712,61.3436237 Z",
    fill: "#002C4B",
    fillRule: "nonzero",
    transform: "translate(128.000000, 95.000000) scale(-1, 1) translate(-128.000000, -95.000000) "
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M113.396882,64 L142.608177,64 C144.399254,64 146.053521,64.958025 146.944933,66.5115174 L161.577138,92.0115174 C162.461464,93.5526583 162.461464,95.4473417 161.577138,96.9884826 L146.944933,122.488483 C146.053521,124.041975 144.399254,125 142.608177,125 L113.396882,125 C111.605806,125 109.951539,124.041975 109.060126,122.488483 L94.4279211,96.9884826 C93.543596,95.4473417 93.543596,93.5526583 94.4279211,92.0115174 L109.060126,66.5115174 C109.951539,64.958025 111.605806,64 113.396882,64 Z M138.987827,70.2765273 C140.779849,70.2765273 142.434839,71.2355558 143.325899,72.7903404 L154.343038,92.0138131 C155.225607,93.5537825 155.225607,95.4462175 154.343038,96.9861869 L143.325899,116.20966 C142.434839,117.764444 140.779849,118.723473 138.987827,118.723473 L117.017233,118.723473 C115.225211,118.723473 113.570221,117.764444 112.67916,116.20966 L101.662022,96.9861869 C100.779452,95.4462175 100.779452,93.5537825 101.662022,92.0138131 L112.67916,72.7903404 C113.570221,71.2355558 115.225211,70.2765273 117.017233,70.2765273 L138.987827,70.2765273 Z M135.080648,77.1414791 L120.924411,77.1414791 C119.134228,77.1414791 117.480644,78.0985567 116.5889,79.6508285 L116.5889,79.6508285 L109.489217,92.0093494 C108.603232,93.5515958 108.603232,95.4484042 109.489217,96.9906506 L109.489217,96.9906506 L116.5889,109.349172 C117.480644,110.901443 119.134228,111.858521 120.924411,111.858521 L120.924411,111.858521 L135.080648,111.858521 C136.870831,111.858521 138.524416,110.901443 139.41616,109.349172 L139.41616,109.349172 L146.515843,96.9906506 C147.401828,95.4484042 147.401828,93.5515958 146.515843,92.0093494 L146.515843,92.0093494 L139.41616,79.6508285 C138.524416,78.0985567 136.870831,77.1414791 135.080648,77.1414791 L135.080648,77.1414791 Z M131.319186,83.7122186 C133.108028,83.7122186 134.760587,84.6678753 135.652827,86.2183156 L138.983552,92.0060969 C139.87203,93.5500005 139.87203,95.4499995 138.983552,96.9939031 L135.652827,102.781684 C134.760587,104.332125 133.108028,105.287781 131.319186,105.287781 L124.685874,105.287781 C122.897032,105.287781 121.244473,104.332125 120.352233,102.781684 L117.021508,96.9939031 C116.13303,95.4499995 116.13303,93.5500005 117.021508,92.0060969 L120.352233,86.2183156 C121.244473,84.6678753 122.897032,83.7122186 124.685874,83.7122186 L131.319186,83.7122186 Z M128.003794,90.1848875 C126.459294,90.1848875 125.034382,91.0072828 124.263005,92.3424437 C123.491732,93.6774232 123.491732,95.3225768 124.263005,96.6575563 C125.034382,97.9927172 126.459294,98.8151125 128.001266,98.8151125 L128.001266,98.8151125 C129.545766,98.8151125 130.970678,97.9927172 131.742055,96.6575563 C132.513327,95.3225768 132.513327,93.6774232 131.742055,92.3424437 C130.970678,91.0072828 129.545766,90.1848875 128.003794,90.1848875 L128.003794,90.1848875 Z M93,94.5009646 L100.767764,94.5009646",
    fill: "#FFD94C"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M87.8601729,108.357758 C89.1715224,107.608286 90.8360246,108.074601 91.5779424,109.399303 L91.5779424,109.399303 L92.0525843,110.24352 C95.8563392,116.982993 99.8190116,123.380176 103.940602,129.435068 C108.807881,136.585427 114.28184,143.82411 120.362479,151.151115 C121.316878,152.30114 121.184944,154.011176 120.065686,154.997937 L120.065686,154.997937 L119.454208,155.534625 C99.3465389,173.103314 86.2778188,176.612552 80.2480482,166.062341 C74.3500652,155.742717 76.4844915,136.982888 86.6513274,109.782853 C86.876818,109.179582 87.3045861,108.675291 87.8601729,108.357758 Z M173.534177,129.041504 C174.986131,128.785177 176.375496,129.742138 176.65963,131.194242 L176.65963,131.194242 L176.812815,131.986376 C181.782365,157.995459 178.283348,171 166.315764,171 C154.609745,171 139.708724,159.909007 121.612702,137.727022 C121.211349,137.235047 120.994572,136.617371 121,135.981509 C121.013158,134.480686 122.235785,133.274651 123.730918,133.287756 L123.730918,133.287756 L124.684654,133.294531 C132.305698,133.335994 139.714387,133.071591 146.910723,132.501323 C155.409039,131.82788 164.283523,130.674607 173.534177,129.041504 Z M180.408726,73.8119663 C180.932139,72.4026903 182.508386,71.6634537 183.954581,72.149012 L183.954581,72.149012 L184.742552,72.4154854 C210.583763,81.217922 220.402356,90.8916805 214.198332,101.436761 C208.129904,111.751366 190.484347,119.260339 161.26166,123.963678 C160.613529,124.067994 159.948643,123.945969 159.382735,123.618843 C158.047025,122.846729 157.602046,121.158214 158.388848,119.847438 L158.388848,119.847438 L158.889328,119.0105 C162.877183,112.31633 166.481358,105.654262 169.701854,99.0242957 C173.50501,91.1948179 177.073967,82.7907081 180.408726,73.8119663 Z M94.7383398,66.0363218 C95.3864708,65.9320063 96.0513565,66.0540315 96.6172646,66.3811573 C97.9529754,67.153271 98.3979538,68.8417862 97.6111517,70.1525615 L97.6111517,70.1525615 L97.1106718,70.9895001 C93.1228168,77.6836699 89.5186416,84.3457379 86.2981462,90.9757043 C82.49499,98.8051821 78.9260328,107.209292 75.5912744,116.188034 C75.0678608,117.59731 73.4916142,118.336546 72.045419,117.850988 L72.045419,117.850988 L71.2574475,117.584515 C45.4162372,108.782078 35.597644,99.1083195 41.8016679,88.5632391 C47.8700957,78.2486335 65.515653,70.7396611 94.7383398,66.0363218 Z M136.545792,34.4653746 C156.653461,16.8966864 169.722181,13.3874478 175.751952,23.9376587 C181.649935,34.2572826 179.515508,53.0171122 169.348673,80.2171474 C169.123182,80.8204179 168.695414,81.324709 168.139827,81.6422422 C166.828478,82.3917144 165.163975,81.9253986 164.422058,80.6006966 L164.422058,80.6006966 L163.947416,79.7564798 C160.143661,73.0170065 156.180988,66.6198239 152.059398,60.564932 C147.192119,53.4145727 141.71816,46.1758903 135.637521,38.8488847 C134.683122,37.6988602 134.815056,35.9888243 135.934314,35.0020629 L135.934314,35.0020629 Z M90.6842361,18 C102.390255,18 117.291276,29.0909926 135.387298,51.2729777 C135.788651,51.7649527 136.005428,52.3826288 136,53.0184911 C135.986842,54.5193144 134.764215,55.7253489 133.269082,55.7122445 L133.269082,55.7122445 L132.315346,55.7054689 C124.694302,55.6640063 117.285613,55.9284091 110.089277,56.4986773 C101.590961,57.17212 92.7164767,58.325393 83.4658235,59.9584962 C82.0138691,60.2148231 80.6245044,59.2578618 80.3403697,57.805758 L80.3403697,57.805758 L80.1871846,57.0136235 C75.2176347,31.0045412 78.7166519,18 90.6842361,18 Z",
    fill: "#FF4154"
  }))));
}
var Ve = { exports: {} }, Ee = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ye;
function Cr() {
  if (Ye)
    return Ee;
  Ye = 1;
  var e = Ke;
  function t(d, g) {
    return d === g && (d !== 0 || 1 / d === 1 / g) || d !== d && g !== g;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, a = e.useEffect, l = e.useLayoutEffect, i = e.useDebugValue;
  function s(d, g) {
    var c = g(), f = r({ inst: { value: c, getSnapshot: g } }), y = f[0].inst, I = f[1];
    return l(function() {
      y.value = c, y.getSnapshot = g, u(y) && I({ inst: y });
    }, [d, c, g]), a(function() {
      return u(y) && I({ inst: y }), d(function() {
        u(y) && I({ inst: y });
      });
    }, [d]), i(c), c;
  }
  function u(d) {
    var g = d.getSnapshot;
    d = d.value;
    try {
      var c = g();
      return !n(d, c);
    } catch {
      return !0;
    }
  }
  function p(d, g) {
    return g();
  }
  var m = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? p : s;
  return Ee.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : m, Ee;
}
var Se = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Je;
function Ir() {
  return Je || (Je = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = Ke, t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(v) {
      {
        for (var b = arguments.length, w = new Array(b > 1 ? b - 1 : 0), E = 1; E < b; E++)
          w[E - 1] = arguments[E];
        r("error", v, w);
      }
    }
    function r(v, b, w) {
      {
        var E = t.ReactDebugCurrentFrame, X = E.getStackAddendum();
        X !== "" && (b += "%s", w = w.concat([X]));
        var L = w.map(function(W) {
          return String(W);
        });
        L.unshift("Warning: " + b), Function.prototype.apply.call(console[v], console, L);
      }
    }
    function a(v, b) {
      return v === b && (v !== 0 || 1 / v === 1 / b) || v !== v && b !== b;
    }
    var l = typeof Object.is == "function" ? Object.is : a, i = e.useState, s = e.useEffect, u = e.useLayoutEffect, p = e.useDebugValue, m = !1, d = !1;
    function g(v, b, w) {
      m || e.startTransition !== void 0 && (m = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var E = b();
      if (!d) {
        var X = b();
        l(E, X) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), d = !0);
      }
      var L = i({
        inst: {
          value: E,
          getSnapshot: b
        }
      }), W = L[0].inst, H = L[1];
      return u(function() {
        W.value = E, W.getSnapshot = b, c(W) && H({
          inst: W
        });
      }, [v, E, b]), s(function() {
        c(W) && H({
          inst: W
        });
        var te = function() {
          c(W) && H({
            inst: W
          });
        };
        return v(te);
      }, [v]), p(E), E;
    }
    function c(v) {
      var b = v.getSnapshot, w = v.value;
      try {
        var E = b();
        return !l(w, E);
      } catch {
        return !0;
      }
    }
    function f(v, b, w) {
      return b();
    }
    var y = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", I = !y, R = I ? f : g, A = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : R;
    Se.useSyncExternalStore = A, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Se;
}
process.env.NODE_ENV === "production" ? Ve.exports = Cr() : Ve.exports = Ir();
var Er = Ve.exports;
function Sr({
  initialIsOpen: e,
  panelProps: t = {},
  closeButtonProps: n = {},
  toggleButtonProps: r = {},
  position: a = "bottom-left",
  containerElement: l = "aside",
  context: i,
  styleNonce: s,
  panelPosition: u = "bottom",
  errorTypes: p = []
}) {
  const m = o.useRef(null), d = o.useRef(null), [g, c] = M("reactQueryDevtoolsOpen", e), [f, y] = M("reactQueryDevtoolsHeight", ue), [I, R] = M("reactQueryDevtoolsWidth", ue), [A = "bottom", v] = M("reactQueryDevtoolsPanelPosition", u), [b, w] = o.useState(!1), [E, X] = o.useState(!1), L = $n(), W = (S, Z) => {
    if (!S || Z.button !== 0)
      return;
    const V = ge(A);
    X(!0);
    const {
      height: ne,
      width: he
    } = S.getBoundingClientRect(), j = Z.clientX, K = Z.clientY;
    let F = 0;
    const fe = (Y) => {
      Y.preventDefault(), V ? (F = he + (A === "right" ? j - Y.clientX : Y.clientX - j), R(F)) : (F = ne + (A === "bottom" ? K - Y.clientY : Y.clientY - K), y(F)), F < ke ? c(!1) : c(!0);
    }, de = () => {
      E && X(!1), document.removeEventListener("mousemove", fe, !1), document.removeEventListener("mouseUp", de, !1);
    };
    document.addEventListener("mousemove", fe, !1), document.addEventListener("mouseup", de, !1);
  };
  o.useEffect(() => {
    w(g ?? !1);
  }, [g, b, w]), o.useEffect(() => {
    const S = d.current;
    if (S) {
      const Z = () => {
        b && (S.style.visibility = "visible");
      }, V = () => {
        b || (S.style.visibility = "hidden");
      };
      return S.addEventListener("transitionstart", Z), S.addEventListener("transitionend", V), () => {
        S.removeEventListener("transitionstart", Z), S.removeEventListener("transitionend", V);
      };
    }
  }, [b]), o.useEffect(() => {
    var S;
    if (b && (S = m.current) != null && S.parentElement) {
      const {
        parentElement: Z
      } = m.current, V = Be("padding", A), ne = ge(A), he = (({
        padding: K,
        paddingTop: F,
        paddingBottom: fe,
        paddingLeft: de,
        paddingRight: Y
      }) => ({
        padding: K,
        paddingTop: F,
        paddingBottom: fe,
        paddingLeft: de,
        paddingRight: Y
      }))(Z.style), j = () => {
        Z.style.padding = "0px", Z.style.paddingTop = "0px", Z.style.paddingBottom = "0px", Z.style.paddingLeft = "0px", Z.style.paddingRight = "0px", Z.style[V] = (ne ? I : f) + "px";
      };
      if (j(), typeof window < "u")
        return window.addEventListener("resize", j), () => {
          window.removeEventListener("resize", j), Object.entries(he).forEach(([K, F]) => {
            Z.style[K] = F;
          });
        };
    }
  }, [b, A, f, I]);
  const {
    style: H = {},
    ...te
  } = t, {
    style: be = {},
    onClick: T,
    ...ce
  } = r, C = nr({
    position: A,
    devtoolsTheme: h,
    isOpen: b,
    height: f,
    width: I,
    isResizing: E,
    panelStyle: H
  });
  return L() ? /* @__PURE__ */ o.createElement(l, {
    ref: m,
    className: "ReactQueryDevtools",
    "aria-label": "React Query Devtools"
  }, /* @__PURE__ */ o.createElement(yt, {
    theme: h
  }, /* @__PURE__ */ o.createElement(Et, D({
    ref: d,
    context: i,
    styleNonce: s,
    position: A,
    onPositionChange: v,
    showCloseButton: !0,
    closeButtonProps: n
  }, te, {
    style: C,
    isOpen: b,
    setIsOpen: c,
    onDragStart: (S) => W(d.current, S),
    errorTypes: p
  }))), b ? null : /* @__PURE__ */ o.createElement("button", D({
    type: "button"
  }, ce, {
    "aria-label": "Open React Query Devtools",
    "aria-controls": "ReactQueryDevtoolsPanel",
    "aria-haspopup": "true",
    "aria-expanded": "false",
    onClick: (S) => {
      c(!0), T == null || T(S);
    },
    style: {
      background: "none",
      border: 0,
      padding: 0,
      position: "fixed",
      zIndex: 99999,
      display: "inline-flex",
      fontSize: "1.5em",
      margin: ".5em",
      cursor: "pointer",
      width: "fit-content",
      ...a === "top-right" ? {
        top: "0",
        right: "0"
      } : a === "top-left" ? {
        top: "0",
        left: "0"
      } : a === "bottom-right" ? {
        bottom: "0",
        right: "0"
      } : {
        bottom: "0",
        left: "0"
      },
      ...be
    }
  }), /* @__PURE__ */ o.createElement(It, {
    "aria-hidden": !0
  }), /* @__PURE__ */ o.createElement(Le, {
    text: "Open React Query Devtools"
  }))) : null;
}
const O = (e, t, n = !1) => Er.useSyncExternalStore(o.useCallback((r) => n ? () => {
} : e.subscribe(Ht.batchCalls(r)), [e, n]), t, t), Et = /* @__PURE__ */ o.forwardRef(function(t, n) {
  const {
    isOpen: r = !0,
    styleNonce: a,
    setIsOpen: l,
    context: i,
    onDragStart: s,
    onPositionChange: u,
    showCloseButton: p,
    position: m,
    closeButtonProps: d = {},
    errorTypes: g = [],
    ...c
  } = t, {
    onClick: f,
    ...y
  } = d, I = _t({
    context: i
  }), R = I.getQueryCache(), [A, v] = M("reactQueryDevtoolsSortFn", Object.keys(Ce)[0]), [b, w] = M("reactQueryDevtoolsFilter", ""), [E, X] = M("reactQueryDevtoolsBaseSort", 1), L = o.useMemo(() => Ce[A], [A]), W = O(R, () => R.getAll().length, !r), [H, te] = M("reactQueryDevtoolsActiveQueryHash", ""), be = o.useMemo(() => {
    const C = R.getAll();
    if (W === 0)
      return [];
    const S = b ? C.filter((V) => cn(V.queryHash, b).passed) : [...C];
    return L ? S.sort((V, ne) => L(V, ne) * E) : S;
  }, [E, L, b, W, R]), [T, ce] = o.useState(!1);
  return /* @__PURE__ */ o.createElement(yt, {
    theme: h
  }, /* @__PURE__ */ o.createElement(or, D({
    ref: n,
    className: "ReactQueryDevtoolsPanel",
    "aria-label": "React Query Devtools Panel",
    id: "ReactQueryDevtoolsPanel"
  }, c, {
    style: {
      height: ue,
      position: "relative",
      ...c.style
    }
  }), /* @__PURE__ */ o.createElement("style", {
    nonce: a,
    dangerouslySetInnerHTML: {
      __html: `
            .ReactQueryDevtoolsPanel * {
              scrollbar-color: ` + h.backgroundAlt + " " + h.gray + `;
            }

            .ReactQueryDevtoolsPanel *::-webkit-scrollbar, .ReactQueryDevtoolsPanel scrollbar {
              width: 1em;
              height: 1em;
            }

            .ReactQueryDevtoolsPanel *::-webkit-scrollbar-track, .ReactQueryDevtoolsPanel scrollbar-track {
              background: ` + h.backgroundAlt + `;
            }

            .ReactQueryDevtoolsPanel *::-webkit-scrollbar-thumb, .ReactQueryDevtoolsPanel scrollbar-thumb {
              background: ` + h.gray + `;
              border-radius: .5em;
              border: 3px solid ` + h.backgroundAlt + `;
            }
          `
    }
  }), /* @__PURE__ */ o.createElement("div", {
    style: rr(m),
    onMouseDown: s
  }), r && /* @__PURE__ */ o.createElement("div", {
    style: {
      flex: "1 1 500px",
      minHeight: "40%",
      maxHeight: "100%",
      overflow: "auto",
      borderRight: "1px solid " + h.grayAlt,
      display: "flex",
      flexDirection: "column"
    }
  }, /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: ".5em",
      background: h.backgroundAlt,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, /* @__PURE__ */ o.createElement("button", {
    type: "button",
    "aria-label": "Close React Query Devtools",
    "aria-controls": "ReactQueryDevtoolsPanel",
    "aria-haspopup": "true",
    "aria-expanded": "true",
    onClick: () => l(!1),
    style: {
      display: "inline-flex",
      background: "none",
      border: 0,
      padding: 0,
      marginRight: ".5em",
      cursor: "pointer"
    }
  }, /* @__PURE__ */ o.createElement(It, {
    "aria-hidden": !0
  }), /* @__PURE__ */ o.createElement(Le, {
    text: "Close React Query Devtools"
  })), /* @__PURE__ */ o.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column"
    }
  }, /* @__PURE__ */ o.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: ".5em"
    }
  }, /* @__PURE__ */ o.createElement(xr, {
    queryCache: R
  }), m && u ? /* @__PURE__ */ o.createElement(Ge, {
    "aria-label": "Panel position",
    value: m,
    style: {
      marginInlineStart: ".5em"
    },
    onChange: (C) => u(C.target.value)
  }, /* @__PURE__ */ o.createElement("option", {
    value: "left"
  }, "Left"), /* @__PURE__ */ o.createElement("option", {
    value: "right"
  }, "Right"), /* @__PURE__ */ o.createElement("option", {
    value: "top"
  }, "Top"), /* @__PURE__ */ o.createElement("option", {
    value: "bottom"
  }, "Bottom")) : null), /* @__PURE__ */ o.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "0.5em"
    }
  }, /* @__PURE__ */ o.createElement(lr, {
    placeholder: "Filter",
    "aria-label": "Filter by queryhash",
    value: b ?? "",
    onChange: (C) => w(C.target.value),
    onKeyDown: (C) => {
      C.key === "Escape" && w("");
    },
    style: {
      flex: "1",
      width: "100%"
    }
  }), /* @__PURE__ */ o.createElement(Ge, {
    "aria-label": "Sort queries",
    value: A,
    onChange: (C) => v(C.target.value),
    style: {
      flex: "1",
      minWidth: 75,
      marginRight: ".5em"
    }
  }, Object.keys(Ce).map((C) => /* @__PURE__ */ o.createElement("option", {
    key: C,
    value: C
  }, "Sort by ", C))), /* @__PURE__ */ o.createElement(N, {
    type: "button",
    onClick: () => X((C) => C * -1),
    style: {
      padding: ".3em .4em",
      marginRight: ".5em"
    }
  }, E === 1 ? "⬆ Asc" : "⬇ Desc"), /* @__PURE__ */ o.createElement(N, {
    title: "Clear cache",
    "aria-label": "Clear cache",
    type: "button",
    onClick: () => R.clear(),
    style: {
      padding: ".3em .4em",
      marginRight: ".5em"
    }
  }, "Clear"), /* @__PURE__ */ o.createElement(N, {
    type: "button",
    onClick: () => {
      T ? (Ne.setOnline(void 0), ce(!1), window.dispatchEvent(new Event("online"))) : (Ne.setOnline(!1), ce(!0));
    },
    "aria-label": T ? "Restore offline mock" : "Mock offline behavior",
    title: T ? "Restore offline mock" : "Mock offline behavior",
    style: {
      padding: "0",
      height: "2em"
    }
  }, /* @__PURE__ */ o.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "2em",
    height: "2em",
    viewBox: "0 0 24 24",
    stroke: T ? h.danger : "currentColor",
    fill: "none"
  }, T ? /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /* @__PURE__ */ o.createElement("line", {
    x1: "12",
    y1: "18",
    x2: "12.01",
    y2: "18"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M9.172 15.172a4 4 0 0 1 5.656 0"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M6.343 12.343a7.963 7.963 0 0 1 3.864 -2.14m4.163 .155a7.965 7.965 0 0 1 3.287 2"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M3.515 9.515a12 12 0 0 1 3.544 -2.455m3.101 -.92a12 12 0 0 1 10.325 3.374"
  }), /* @__PURE__ */ o.createElement("line", {
    x1: "3",
    y1: "3",
    x2: "21",
    y2: "21"
  })) : /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /* @__PURE__ */ o.createElement("line", {
    x1: "12",
    y1: "18",
    x2: "12.01",
    y2: "18"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M9.172 15.172a4 4 0 0 1 5.656 0"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M6.343 12.343a8 8 0 0 1 11.314 0"
  }), /* @__PURE__ */ o.createElement("path", {
    d: "M3.515 9.515c4.686 -4.687 12.284 -4.687 17 0"
  }))), /* @__PURE__ */ o.createElement(Le, {
    text: T ? "Restore offline mock" : "Mock offline behavior"
  }))))), /* @__PURE__ */ o.createElement("div", {
    style: {
      overflowY: "auto",
      flex: "1"
    }
  }, be.map((C) => /* @__PURE__ */ o.createElement(St, {
    queryKey: C.queryKey,
    activeQueryHash: H,
    setActiveQueryHash: te,
    key: C.queryHash,
    queryCache: R
  })))), H && r ? /* @__PURE__ */ o.createElement(Ar, {
    activeQueryHash: H,
    queryCache: R,
    queryClient: I,
    errorTypes: g
  }) : null, p ? /* @__PURE__ */ o.createElement(N, D({
    type: "button",
    "aria-controls": "ReactQueryDevtoolsPanel",
    "aria-haspopup": "true",
    "aria-expanded": "true"
  }, y, {
    style: {
      position: "absolute",
      zIndex: 99999,
      margin: ".5em",
      bottom: 0,
      left: 0,
      ...y.style
    },
    onClick: (C) => {
      l(!1), f == null || f(C);
    }
  }), "Close") : null));
}), Ar = ({
  queryCache: e,
  activeQueryHash: t,
  queryClient: n,
  errorTypes: r
}) => {
  var a, l;
  const i = O(e, () => e.getAll().find((f) => f.queryHash === t)), s = O(e, () => {
    var f;
    return (f = e.getAll().find((y) => y.queryHash === t)) == null ? void 0 : f.state;
  }), u = (a = O(e, () => {
    var f;
    return (f = e.getAll().find((y) => y.queryHash === t)) == null ? void 0 : f.isStale();
  })) != null ? a : !1, p = (l = O(e, () => {
    var f;
    return (f = e.getAll().find((y) => y.queryHash === t)) == null ? void 0 : f.getObserversCount();
  })) != null ? l : 0, m = () => {
    const f = i == null ? void 0 : i.fetch();
    f == null || f.catch(wr);
  }, d = Qt(() => {
    if (i && s != null && s.error) {
      const f = r.find((y) => {
        var I;
        return y.initializer(i).toString() === ((I = s.error) == null ? void 0 : I.toString());
      });
      return f == null ? void 0 : f.name;
    }
  }, [i, s == null ? void 0 : s.error, r]);
  if (!i || !s)
    return null;
  const g = (f) => {
    var y;
    const I = (y = f == null ? void 0 : f.initializer(i)) != null ? y : new Error("Unknown error from devtools"), R = i.options;
    i.setState({
      status: "error",
      error: I,
      fetchMeta: {
        ...i.state.fetchMeta,
        __previousQueryOptions: R
      }
    });
  }, c = () => {
    i.fetch(i.state.fetchMeta.__previousQueryOptions, {
      // Make sure this fetch will cancel the previous one
      cancelRefetch: !0
    });
  };
  return /* @__PURE__ */ o.createElement(ar, null, /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: ".5em",
      background: h.backgroundAlt,
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, "Query Details"), /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: ".5em"
    }
  }, /* @__PURE__ */ o.createElement("div", {
    style: {
      marginBottom: ".5em",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between"
    }
  }, /* @__PURE__ */ o.createElement(z, {
    style: {
      lineHeight: "1.8em"
    }
  }, /* @__PURE__ */ o.createElement("pre", {
    style: {
      margin: 0,
      padding: 0,
      overflow: "auto"
    }
  }, ht(i.queryKey, !0))), /* @__PURE__ */ o.createElement("span", {
    style: {
      padding: "0.3em .6em",
      borderRadius: "0.4em",
      fontWeight: "bold",
      textShadow: "0 2px 10px black",
      background: bt({
        queryState: s,
        isStale: u,
        observerCount: p,
        theme: h
      }),
      flexShrink: 0
    }
  }, $(i))), /* @__PURE__ */ o.createElement("div", {
    style: {
      marginBottom: ".5em",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  }, "Observers: ", /* @__PURE__ */ o.createElement(z, null, p)), /* @__PURE__ */ o.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  }, "Last Updated:", " ", /* @__PURE__ */ o.createElement(z, null, new Date(s.dataUpdatedAt).toLocaleTimeString()))), /* @__PURE__ */ o.createElement("div", {
    style: {
      background: h.backgroundAlt,
      padding: ".5em",
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, "Actions"), /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: "0.5em",
      display: "flex",
      flexWrap: "wrap",
      gap: "0.5em",
      alignItems: "flex-end"
    }
  }, /* @__PURE__ */ o.createElement(N, {
    type: "button",
    onClick: m,
    disabled: s.fetchStatus === "fetching",
    style: {
      background: h.active
    }
  }, "Refetch"), " ", /* @__PURE__ */ o.createElement(N, {
    type: "button",
    onClick: () => n.invalidateQueries(i),
    style: {
      background: h.warning,
      color: h.inputTextColor
    }
  }, "Invalidate"), " ", /* @__PURE__ */ o.createElement(N, {
    type: "button",
    onClick: () => n.resetQueries(i),
    style: {
      background: h.gray
    }
  }, "Reset"), " ", /* @__PURE__ */ o.createElement(N, {
    type: "button",
    onClick: () => n.removeQueries(i),
    style: {
      background: h.danger
    }
  }, "Remove"), " ", /* @__PURE__ */ o.createElement(N, {
    type: "button",
    onClick: () => {
      var f;
      if (!(i.state.fetchStatus === "fetching" && typeof ((f = i.state.fetchMeta) == null ? void 0 : f.__previousQueryOptions) > "u"))
        if (i.state.data === void 0)
          c();
        else {
          const y = i.options;
          i.fetch({
            ...y,
            queryFn: () => new Promise(() => {
            }),
            cacheTime: -1
          }), i.setState({
            data: void 0,
            status: "loading",
            fetchMeta: {
              ...i.state.fetchMeta,
              __previousQueryOptions: y
            }
          });
        }
    },
    style: {
      background: h.paused
    }
  }, i.state.status === "loading" ? "Restore" : "Trigger", " ", "loading"), " ", r.length === 0 || i.state.status === "error" ? /* @__PURE__ */ o.createElement(N, {
    type: "button",
    onClick: () => {
      i.state.error ? n.resetQueries(i) : g();
    },
    style: {
      background: h.danger
    }
  }, i.state.status === "error" ? "Restore" : "Trigger", " error") : /* @__PURE__ */ o.createElement("label", null, "Trigger error:", /* @__PURE__ */ o.createElement(Ge, {
    value: d ?? "",
    style: {
      marginInlineStart: ".5em"
    },
    onChange: (f) => {
      const y = r.find((I) => I.name === f.target.value);
      g(y);
    }
  }, /* @__PURE__ */ o.createElement("option", {
    key: "",
    value: ""
  }), r.map((f) => /* @__PURE__ */ o.createElement("option", {
    key: f.name,
    value: f.name
  }, f.name))))), /* @__PURE__ */ o.createElement("div", {
    style: {
      background: h.backgroundAlt,
      padding: ".5em",
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, "Data Explorer"), /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: ".5em"
    }
  }, /* @__PURE__ */ o.createElement(Xe, {
    label: "Data",
    value: s.data,
    defaultExpanded: {},
    copyable: !0
  })), /* @__PURE__ */ o.createElement("div", {
    style: {
      background: h.backgroundAlt,
      padding: ".5em",
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, "Query Explorer"), /* @__PURE__ */ o.createElement("div", {
    style: {
      padding: ".5em"
    }
  }, /* @__PURE__ */ o.createElement(Xe, {
    label: "Query",
    value: i,
    defaultExpanded: {
      queryKey: !0
    }
  })));
}, xr = ({
  queryCache: e
}) => {
  const t = O(e, () => e.getAll().filter((i) => $(i) === "fresh").length), n = O(e, () => e.getAll().filter((i) => $(i) === "fetching").length), r = O(e, () => e.getAll().filter((i) => $(i) === "paused").length), a = O(e, () => e.getAll().filter((i) => $(i) === "stale").length), l = O(e, () => e.getAll().filter((i) => $(i) === "inactive").length);
  return /* @__PURE__ */ o.createElement(ir, null, /* @__PURE__ */ o.createElement(re, {
    style: {
      background: h.success,
      opacity: t ? 1 : 0.3
    }
  }, "fresh ", /* @__PURE__ */ o.createElement(z, null, "(", t, ")")), " ", /* @__PURE__ */ o.createElement(re, {
    style: {
      background: h.active,
      opacity: n ? 1 : 0.3
    }
  }, "fetching ", /* @__PURE__ */ o.createElement(z, null, "(", n, ")")), " ", /* @__PURE__ */ o.createElement(re, {
    style: {
      background: h.paused,
      opacity: r ? 1 : 0.3
    }
  }, "paused ", /* @__PURE__ */ o.createElement(z, null, "(", r, ")")), " ", /* @__PURE__ */ o.createElement(re, {
    style: {
      background: h.warning,
      color: "black",
      textShadow: "0",
      opacity: a ? 1 : 0.3
    }
  }, "stale ", /* @__PURE__ */ o.createElement(z, null, "(", a, ")")), " ", /* @__PURE__ */ o.createElement(re, {
    style: {
      background: h.gray,
      opacity: l ? 1 : 0.3
    }
  }, "inactive ", /* @__PURE__ */ o.createElement(z, null, "(", l, ")")));
}, St = /* @__PURE__ */ o.memo(({
  queryKey: e,
  setActiveQueryHash: t,
  activeQueryHash: n,
  queryCache: r
}) => {
  var a, l, i, s;
  const u = (a = O(r, () => {
    var c;
    return (c = r.find(e)) == null ? void 0 : c.queryHash;
  })) != null ? a : "", p = O(r, () => {
    var c;
    return (c = r.find(e)) == null ? void 0 : c.state;
  }), m = (l = O(r, () => {
    var c;
    return (c = r.find(e)) == null ? void 0 : c.isStale();
  })) != null ? l : !1, d = (i = O(r, () => {
    var c;
    return (c = r.find(e)) == null ? void 0 : c.isDisabled();
  })) != null ? i : !1, g = (s = O(r, () => {
    var c;
    return (c = r.find(e)) == null ? void 0 : c.getObserversCount();
  })) != null ? s : 0;
  return p ? /* @__PURE__ */ o.createElement("div", {
    role: "button",
    "aria-label": "Open query details for " + u,
    onClick: () => t(n === u ? "" : u),
    style: {
      display: "flex",
      borderBottom: "solid 1px " + h.grayAlt,
      cursor: "pointer",
      background: u === n ? "rgba(255,255,255,.1)" : void 0
    }
  }, /* @__PURE__ */ o.createElement("div", {
    style: {
      flex: "0 0 auto",
      width: "2em",
      height: "2em",
      background: bt({
        queryState: p,
        isStale: m,
        observerCount: g,
        theme: h
      }),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "bold",
      textShadow: m ? "0" : "0 0 10px black",
      color: m ? "black" : "white"
    }
  }, g), d ? /* @__PURE__ */ o.createElement("div", {
    style: {
      flex: "0 0 auto",
      height: "2em",
      background: h.gray,
      display: "flex",
      alignItems: "center",
      fontWeight: "bold",
      padding: "0 0.5em"
    }
  }, "disabled") : null, /* @__PURE__ */ o.createElement(z, {
    style: {
      padding: ".5em"
    }
  }, "" + u)) : null;
});
St.displayName = "QueryRow";
function wr() {
}
const Rr = process.env.NODE_ENV !== "development" ? function() {
  return null;
} : Sr;
process.env.NODE_ENV;
const Zr = {
  origins: !0,
  priority: !0,
  timeout: 2e3,
  throttle: 1,
  limit: 2,
  // 동시에 최대 2개 URL만 prefetch
  ignores: [
    // API 엔드포인트 무시
    /\/api\//,
    // 파일 다운로드 무시
    /\.(zip|pdf|doc|docx|xls|xlsx|ppt|pptx)$/i,
    // noprefetch 속성이 있는 링크 무시
    (e, t) => (t == null ? void 0 : t.hasAttribute("noprefetch")) ?? !1,
    // 해시가 포함된 URL 무시 (SPA 라우팅)
    (e) => e.includes("#"),
    // 해당 2개 URL만 허용(그 외는 모두 무시)
    (e) => {
      try {
        const t = new URL(e, window.location.origin), n = `${t.origin}${t.pathname}`;
        return !(/* @__PURE__ */ new Set()).has(n);
      } catch {
        return !0;
      }
    }
  ]
};
function Wr() {
  return Zr;
}
const Or = je({
  containerId: "MVM7ZHX",
  customScriptSrc: "https://www.inflearn.com/mvm7zhx/s.js"
}), kr = Object.assign({}, je({
  containerId: "58GKPFHR",
  dataLayerName: "commonDataLayer",
  customScriptSrc: "https://www.inflearn.com/58gkpfhr/s.js"
}), {
  name: "common"
}), Gr = new Tt({
  defaultOptions: {
    queries: {
      retry: 0,
      suspense: !0,
      useErrorBoundary: !0,
      refetchOnWindowFocus: !1
    },
    mutations: {
      useErrorBoundary: !0
    }
  },
  logger: {
    log: console.log,
    error: console.log,
    warn: console.log
  }
});
function mo({
  children: e,
  analytics: t,
  disableAnalyticsPlugins: n = !1,
  queryClient: r = Gr,
  navigate: a = wt,
  withNormalizeCSS: l = !0,
  quicklinkConfig: i = Wr()
}) {
  const [s] = zt(() => t || At({
    app: "inflearn-monolith",
    plugins: n ? [] : [Or, kr]
  })), u = t ?? s;
  return $e(function() {
    (async () => {
      await $t(i);
    })().catch((d) => {
      console.error("Failed to initialize quicklink:", d);
    });
  }, [i]), /* @__PURE__ */ x(xt, { navigate: a, children: /* @__PURE__ */ x(Xt, { cdnLink: _e, withNormalizeCSS: l, children: /* @__PURE__ */ oe(Vt, { cdnLink: _e, reset: {}, children: [
    /* @__PURE__ */ x(Bt, {}),
    /* @__PURE__ */ x(Nt, { children: /* @__PURE__ */ oe(Ft, { client: r, children: [
      /* @__PURE__ */ x(Gt, { styles: [Mt, Kt, process.env.NODE_ENV === "production" ? "" : ";label:AppShellProvider;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"] }),
      /* @__PURE__ */ x(Lt, { analytics: u, children: e }),
      qe !== "production" && /* @__PURE__ */ x(Rr, { initialIsOpen: !1 })
    ] }) })
  ] }) }) });
}
function Lr({
  children: e
}) {
  const t = qt(Pt, {
    pollingIntervalMillis: 3e4,
    exposureEventDedupIntervalMillis: 1e3,
    autoOpenDevTool: qe !== "production",
    eventUrl: "https://gt.inflearn.com/hk-event",
    sdkUrl: "https://gt.inflearn.com/hk-sdk"
  }), n = Ut.get("deviceId"), r = n ? String(n) : void 0;
  return $e(() => {
    !t || !r || t.setDeviceId(r);
  }, [r, t]), /* @__PURE__ */ x(en, { hackleClient: t, supportSSR: !0, children: e });
}
function Xr({
  header: e,
  footer: t,
  children: n,
  disableBottomNavigation: r,
  isShowingLoginNeededNotification: a = !1,
  showChanneltalk: l = !1,
  showMoveTop: i = !1,
  isAntMan: s = !1
}) {
  const u = Rt();
  return /* @__PURE__ */ oe(Yt, { isShowing: a ?? !1, children: [
    /* @__PURE__ */ x(Zt, {}),
    /* @__PURE__ */ oe(Wt, { children: [
      i ? /* @__PURE__ */ x(nn, { isAntMan: s ?? !1 }) : null,
      u && /* @__PURE__ */ x(Ot, {}),
      /* @__PURE__ */ oe(kt, { children: [
        e,
        /* @__PURE__ */ x("div", { id: Jt.CHILDREN_WRAPPER, style: {
          backgroundColor: "white"
        }, children: n }),
        t && Dt(t, {
          hasBottomNavigation: !r
        }),
        /* @__PURE__ */ x(jt, { children: r ? null : /* @__PURE__ */ x(on, {}) }),
        l ? /* @__PURE__ */ x(tn, {}) : null,
        /* @__PURE__ */ x(an, {})
      ] })
    ] })
  ] });
}
function go(e) {
  return /* @__PURE__ */ x(rn, { children: /* @__PURE__ */ x(Lr, { children: /* @__PURE__ */ x(Xr, { ...e }) }) });
}
export {
  go as AppShell,
  mo as AppShellProvider,
  ho as Header
};
